function n(n, r) {
  var t;
  return function () {
    return --n > 0 && (t = r.apply(this, arguments)), n <= 1 && (r = null), t;
  };
}
export { n as default };